module.exports = __webpack_public_path__ + "static/media/diary_unlock_huhuLogo.a3eccb8b.png";